import pegasus from "../../build/global/js/00-pegasus";

window.counters = () => {
    return{
        visible: false,
        startTime: null,
        startCount(){
            let currentTime = Date.now();

            const step = (currentTime) => {

                if (!this.startTime) {
                    this.startTime = currentTime ;
                }

                const progress = Math.min((currentTime  - this.startTime) / 1500, 1);

                this.$refs.number.innerHTML = pegasus.numberWithCommas(Math.floor(progress * (parseInt(this.$refs.number.dataset.counterNumber))));

                if (progress < 1) {
                    window.requestAnimationFrame(step);
                }
                else{
                    window.cancelAnimationFrame(window.requestAnimationFrame(step));
                }
            };

            window.requestAnimationFrame(step);

        }
    }
}